const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const formatMessage = require('format-message');
const faceLandmarksDetection = require('@tensorflow-models/face-landmarks-detection');
require('@tensorflow/tfjs-backend-webgl');
const { TRIANGULATION } = require('./triangulation.js'); // Path to triangulation indices, can be loaded dynamically if needed
const StageLayering = require('../../engine/stage-layering');

const menuIconURI = 'data:image/svg+xml;base64,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'

class Scratch3FaceDetectionExtension {
    constructor(runtime) {
        this.runtime = runtime;
        this.video = this.runtime.ioDevices.video;
        this.modelLoaded = false;
        this.faces = [];
        this.confidenceThreshold = 0.5;
        this.detector = null;
        this.canvas = null;
        this.ctx = null;
        this.penSkinId = -1;
        this.penDrawableId = -1;
        this.maxFaces = 1;
        this.activeDetectionPromise = null;
        this._initPromise = this._initialize();
        this._initializePenLayer();
        this._lastDetectionTime = 0;

        // Turn off camera and clear drawings when a project is loaded or switched
        this._onProjectLoaded = this._cleanup.bind(this);
        if (this.runtime) {
            this.runtime.on('PROJECT_LOADED', this._onProjectLoaded);
            this.runtime.on('RUNTIME_DISPOSED', this._onProjectLoaded);
        }
    }

    async _initialize() {
        try {
            const model = faceLandmarksDetection.SupportedModels.MediaPipeFaceMesh;
            const detectorConfig = {
                runtime: 'mediapipe',
                solutionPath: 'https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh',
                maxFaces: this.maxFaces
            };
            this.detector = await faceLandmarksDetection.createDetector(model, detectorConfig);
            this.modelLoaded = true;
            console.log('MediaPipe FaceMesh loaded and ready');
        } catch (error) {
            console.error('Failed to load FaceMesh model:', error);
        }
    }

    _initializePenLayer() {
        if (this.penSkinId < 0 && this.runtime.renderer) {
            this.penSkinId = this.runtime.renderer.createPenSkin();
            this.penDrawableId = this.runtime.renderer.createDrawable(StageLayering.PEN_LAYER);
            this.runtime.renderer.updateDrawableSkinId(this.penDrawableId, this.penSkinId);
        }
    }

    async _getVideoElement(maxWaitMs = 500) {
        if (!this.video) return null;
        const startTime = Date.now();
        while (Date.now() - startTime <= maxWaitMs) {
            const video = this.video.provider && this.video.provider.video;
            if (video && video.videoWidth > 0 && video.videoHeight > 0 && video.readyState >= 2) {
                return video;
            }
            await new Promise(resolve => setTimeout(resolve, 50));
        }
        return null;
    }

    async detectFaces(args) {
        if (!this.modelLoaded && this._initPromise) {
            await this._initPromise;
        }

        if (!this.modelLoaded || !this.detector) return;

        const now = Date.now();
        if (now - this._lastDetectionTime < 100) {
            if (args && args.SHOW_BOUNDING_BOXES === 'show' && this.faces.length > 0) {
                const video = this.video.provider && this.video.provider.video;
                if (video && video.videoWidth > 0) {
                    this._drawFaceMesh(this.faces, video.videoWidth, video.videoHeight);
                }
            }
            return;
        }

        if (this.activeDetectionPromise) {
            return await this.activeDetectionPromise;
        }

        this.activeDetectionPromise = (async () => {
            try {
                const videoElement = await this._getVideoElement(250);
                if (!videoElement) return;

                this._lastDetectionTime = Date.now();
                const faces = await this.detector.estimateFaces(videoElement, {
                    flipHorizontal: true,
                    predictIrises: true,
                    minConfidence: this.confidenceThreshold
                });

                this.faces = faces || [];

                if (args && args.SHOW_BOUNDING_BOXES === 'show') {
                    this._drawFaceMesh(this.faces, videoElement.videoWidth, videoElement.videoHeight);
                }
                this.runtime.requestRedraw();
            } catch (err) {
                console.warn('Face detection pass skipped:', err.message || err);
            } finally {
                this.activeDetectionPromise = null;
            }
        })();

        return await this.activeDetectionPromise;
    }

    _clearPenLayer() {
        if (this.penSkinId >= 0) {
            this.runtime.renderer.penClear(this.penSkinId);
        }
    }

    async moveSpriteWithFace(args) {
        const faceIndex = Number(args && args.FACE_INDEX) || 0;
        if (faceIndex < 1 || faceIndex > this.faces.length) return;
        const face = this.faces[faceIndex - 1];
        const video = this.video.provider && this.video.provider.video;
        if (!video || !video.videoWidth || !video.videoHeight) return;

        let x, y;
        if (face.boundingBox) {
            // Use bounding box center if available
            x = face.boundingBox.x + face.boundingBox.width / 2;
            y = face.boundingBox.y + face.boundingBox.height / 2;
        } else if (face.keypoints && face.keypoints.length > 0) {
            // Fallback: use average of keypoints
            x = face.keypoints.reduce((sum, pt) => sum + pt.x, 0) / face.keypoints.length;
            y = face.keypoints.reduce((sum, pt) => sum + pt.y, 0) / face.keypoints.length;
        } else {
            return;
        }

        const stageWidth = 480;
        const stageHeight = 360;

        const spriteX = ((x / video.videoWidth - 0.5) * stageWidth);
        const spriteY = (0.5 - y / video.videoHeight) * stageHeight;

        const sprite = this.runtime.getEditingTarget();
        if (sprite && sprite.setXY) sprite.setXY(spriteX, spriteY);
    }

    async detectFaceLandmark(args) {
        const faceIndex = Number(args && args.FACE_INDEX) || 0;
        if (faceIndex < 1 || faceIndex > this.faces.length) return;
        const face = this.faces[faceIndex - 1];
        if (!face.keypoints || face.keypoints.length === 0) return;

        let pt;
        switch (args.LANDMARK) {
            case 'nose':
                pt = face.keypoints.find(k => k.name && k.name.toLowerCase().includes('nose'));
                break;
            case 'leftEye':
                pt = face.keypoints.find(k => k.name && k.name.toLowerCase().includes('left') && k.name.toLowerCase().includes('eye'));
                break;
            case 'rightEye':
                pt = face.keypoints.find(k => k.name && k.name.toLowerCase().includes('right') && k.name.toLowerCase().includes('eye'));
                break;
            case 'mouth':
                pt = face.keypoints.find(k => k.name && k.name.toLowerCase().includes('mouth'));
                break;
        }
        // Fallback: use a likely index if name is missing
        if (!pt) {
            if (args.LANDMARK === 'nose') pt = face.keypoints[1];
            if (args.LANDMARK === 'leftEye') pt = face.keypoints[33];
            if (args.LANDMARK === 'rightEye') pt = face.keypoints[263];
            if (args.LANDMARK === 'mouth') pt = face.keypoints[13];
        }
        if (!pt) return;
        const video = this.video.provider && this.video.provider.video;
        if (!video || !video.videoWidth || !video.videoHeight) return;
        const stageWidth = 480;
        const stageHeight = 360;

        const spriteX = (pt.x / video.videoWidth - 0.5) * stageWidth;
        const spriteY = (0.5 - pt.y / video.videoHeight) * stageHeight;

        const sprite = this.runtime.getEditingTarget();
        if (sprite && sprite.setXY) sprite.setXY(spriteX, spriteY);
    }

    videoToggle(args) {
        const state = args.VIDEO_STATE;
        if (state === 'off') {
            this.runtime.ioDevices.video.disableVideo();
            try {
                localStorage.setItem('isCameraOpen', JSON.stringify(false));
            } catch (e) {}
        } else {
            this.runtime.ioDevices.video.enableVideo().then(() => {
                this.runtime.ioDevices.video.mirror = true;
                try {
                    localStorage.setItem('isCameraOpen', JSON.stringify(true));
                } catch (e) {}
            }).catch(err => {
                console.error("Error enabling video: ", err);
            });
        }
    }

    getDetectedFaceCount() {
        return this.faces.length;
    }

    clearCanvas() {
        this._clearPenLayer();
    }

    /**
     * Turn off camera, clear pen layer, and reset face state.
     * Called automatically on PROJECT_LOADED / RUNTIME_DISPOSED.
     */
    _cleanup() {
        // Turn off the camera
        try {
            if (this.video) {
                this.video.disableVideo();
            }
        } catch (e) {}

        // Clear pen drawings
        this._clearPenLayer();

        // Reset detection state
        this.faces = [];
        this.activeDetectionPromise = null;
        this._lastDetectionTime = 0;
    }

    dispose() {
        // Deregister event listeners to avoid memory leaks
        if (this.runtime && this._onProjectLoaded) {
            this.runtime.removeListener('PROJECT_LOADED', this._onProjectLoaded);
            this.runtime.removeListener('RUNTIME_DISPOSED', this._onProjectLoaded);
        }
        this._cleanup();
    }

    async setMaxFaces(args) {
        let n = Math.round(Number(args.MAXFACES));
        if (isNaN(n) || n < 1) n = 1;
        if (n > 10) n = 10;
        if (this.maxFaces === n) return;
        this.maxFaces = n;

        // Recreate the detector with new maxFaces
        const model = faceLandmarksDetection.SupportedModels.MediaPipeFaceMesh;
        const detectorConfig = {
            runtime: 'mediapipe',
            solutionPath: 'https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh',
            maxFaces: this.maxFaces
        };
        this.detector = await faceLandmarksDetection.createDetector(model, detectorConfig);
    }

    getDetectedFaceProperty(args) {
        const index = Math.max(0, Math.floor(args.FACE_INDEX) - 1);
        const property = args.PROPERTY;
        if (index < this.faces.length) {
            const face = this.faces[index];
            const box = face.boundingBox;
            switch (property) {
                case 'x':
                    return Math.round(box.x);
                case 'y':
                    return Math.round(box.y);
                case 'width':
                    return Math.round(box.width);
                case 'height':
                    return Math.round(box.height);
                case 'confidence':
                    return 'N/A'; // MediaPipeFaceDetector does not provide confidence per box
                default:
                    return 'Unknown property';
            }
        } else {
            return 'No face at this index';
        }
    }

    setConfidenceThreshold(args) {
        let threshold = parseFloat(args.THRESHOLD);
        if (isNaN(threshold)) threshold = 0.5;
        this.confidenceThreshold = Math.max(0, Math.min(1, threshold));
        return this.confidenceThreshold;
    }

    _drawFaceMesh(faces, videoWidth, videoHeight) {
        this._clearPenLayer();
        if (!this.penSkinId) return;
        const stageWidth = 480, stageHeight = 360;
        const scaleX = stageWidth / videoWidth;
        const scaleY = stageHeight / videoHeight;
        // Blue, mostly transparent for inner lines
        const meshLineAttributes = { color4f: [0.486, 0.941, 0.502, 0.59], diameter: 1 };
        // Blue, fully opaque for points
        const meshPointAttributes = { color4f: [0.486, 0.941, 0.502, 0.89], diameter: 1 };

        (faces.slice(0, this.maxFaces)).forEach(face => {
            if (!face.keypoints || face.keypoints.length === 0) {
                console.warn('Face mesh not available for face', face);
                return;
            }
            const mesh = face.keypoints.map(pt => [pt.x, pt.y]);
            // Draw mesh triangles (lines)
            for (let i = 0; i < TRIANGULATION.length; i += 3) {
                const a = mesh[TRIANGULATION[i]];
                const b = mesh[TRIANGULATION[i + 1]];
                const c = mesh[TRIANGULATION[i + 2]];
                if (a && b && c) {
                    const ax = a[0] * scaleX - stageWidth / 2;
                    const ay = stageHeight / 2 - a[1] * scaleY;
                    const bx = b[0] * scaleX - stageWidth / 2;
                    const by = stageHeight / 2 - b[1] * scaleY;
                    const cx = c[0] * scaleX - stageWidth / 2;
                    const cy = stageHeight / 2 - c[1] * scaleY;
                    this.runtime.renderer.penLine(this.penSkinId, meshLineAttributes, ax, ay, bx, by);
                    this.runtime.renderer.penLine(this.penSkinId, meshLineAttributes, bx, by, cx, cy);
                    this.runtime.renderer.penLine(this.penSkinId, meshLineAttributes, cx, cy, ax, ay);
                }
            }
            // Draw mesh points (opaque)
            mesh.forEach(([x, y]) => {
                const lx = x * scaleX - stageWidth / 2;
                const ly = stageHeight / 2 - y * scaleY;
                this.runtime.renderer.penLine(
                    this.penSkinId, meshPointAttributes,
                    lx - 1, ly - 1, lx + 1, ly + 1
                );
                this.runtime.renderer.penLine(
                    this.penSkinId, meshPointAttributes,
                    lx - 1, ly + 1, lx + 1, ly - 1
                );
            });
        });
    }

    getInfo() {
        return {
            id: 'face',
            color1: '#ff9f00',
            blockIconURI: menuIconURI,
            menuIconURI: menuIconURI,
            name: formatMessage({
                id: 'face.categoryName',
                default: 'Face Detection',
                description: 'Label for the face detection extension category'
            }),
            blocks: [
                {
                    opcode: 'clearCanvas',
                    text: formatMessage({
                        id: 'face.clearCanvas',
                        default: 'clear face drawing',
                        description: 'Clear the face mesh drawing from the stage'
                    }),
                    blockType: BlockType.COMMAND
                },
                {
                    opcode: 'detectFaces',
                    text: formatMessage({
                        id: 'face.detectFaces',
                        default: 'detect faces and [SHOW_BOUNDING_BOXES] bounding boxes',
                        description: 'Detect faces in the video stream'
                    }),
                    blockType: BlockType.COMMAND,
                    arguments: {
                        SHOW_BOUNDING_BOXES: {
                            type: ArgumentType.STRING,
                            menu: 'showHide',
                            defaultValue: 'show'
                        }
                    }
                },
                {
                    opcode: 'setMaxFaces',
                    text: formatMessage({
                        id: 'face.setMaxFaces',
                        default: 'set max faces to [MAXFACES]',
                        description: 'Set the maximum number of faces to detect'
                    }),
                    blockType: BlockType.COMMAND,
                    arguments: {
                        MAXFACES: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 1,
                            menu: 'maxFaces'
                        }
                    }
                },
                {
                    opcode: 'moveSpriteWithFace',
                    text: formatMessage({
                        id: 'face.moveSpriteWithFace',
                        default: 'move sprite to detected face [FACE_INDEX]',
                        description: 'Move sprite based on detected face'
                    }),
                    blockType: BlockType.COMMAND,
                    arguments: {
                        FACE_INDEX: {
                            type: ArgumentType.NUMBER,
                            menu: 'faceIndices',
                            defaultValue: 1
                        }
                    },
                },
                {
                    opcode: 'detectFaceLandmark',
                    text: formatMessage({
                        id: 'face.detectFaceLandmark',
                        default: 'move sprite to [LANDMARK] of face [FACE_INDEX]',
                        description: 'Move sprite to specific facial landmark'
                    }),
                    blockType: BlockType.COMMAND,
                    arguments: {
                        LANDMARK: {
                            type: ArgumentType.STRING,
                            menu: 'landmarks',
                            defaultValue: 'nose'
                        },
                        FACE_INDEX: {
                            type: ArgumentType.NUMBER,
                            menu: 'faceIndices',
                            defaultValue: 1
                        }
                    }
                },
                {
                    opcode: 'videoToggle',
                    text: formatMessage({
                        id: 'face.videoToggle',
                        default: 'turn video [VIDEO_STATE]',
                        description: 'Enable or disable video feed'
                    }),
                    blockType: BlockType.COMMAND,
                    arguments: {
                        VIDEO_STATE: {
                            type: ArgumentType.STRING,
                            menu: 'onOff',
                            defaultValue: 'on'
                        }
                    }
                },
                {
                    opcode: 'getDetectedFaceCount',
                    text: formatMessage({
                        id: 'face.getDetectedFaceCount',
                        default: 'number of faces detected',
                        description: 'Get the number of faces detected'
                    }),
                    blockType: BlockType.REPORTER
                },
                {
                    opcode: 'getDetectedFaceProperty',
                    text: formatMessage({
                        id: 'face.getDetectedFaceProperty',
                        default: 'face [FACE_INDEX] [PROPERTY]',
                        description: 'Get a specific property of a detected face'
                    }),
                    blockType: BlockType.REPORTER,
                    arguments: {
                        FACE_INDEX: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 1
                        },
                        PROPERTY: {
                            type: ArgumentType.STRING,
                            menu: 'faceProperties',
                            defaultValue: 'x'
                        }
                    }
                },
                {
                    opcode: 'setConfidenceThreshold',
                    text: formatMessage({
                        id: 'face.setConfidenceThreshold',
                        default: 'set confidence threshold to [THRESHOLD]',
                        description: 'Set the confidence threshold for face detection'
                    }),
                    blockType: BlockType.COMMAND,
                    arguments: {
                        THRESHOLD: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0.5
                        }
                    }
                }
            ],
            menus: {
                onOff: ['on', 'off'],
                showHide: ['show', 'hide'],
                faceProperties: ['x', 'y', 'width', 'height', 'confidence'],
                landmarks: ['nose', 'leftEye', 'rightEye', 'mouth'],
                maxFaces: ['1','2','3','4','5','6','7','8','9','10'],
                faceIndices: () => {
                    // Return an array of strings: ['1', '2', ...] up to the number of detected faces
                    const count = this && this.faces ? this.faces.length : 0;
                    const items = [];
                    for (let i = 1; i <= count; i++) items.push(i.toString());
                    return items.length ? items : ['1'];
                },
            }
        };
    }
}

module.exports = Scratch3FaceDetectionExtension;
